import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Sets { withCredentials: true } option on each request.
 */
@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  constructor() {}

  // TODO unit tests
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(
      // TODO limit withCredentials to sibling requests only
      request.clone({
        withCredentials: true,
      }),
    );
  }
}
